// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"d8e02846","3893":"c9dbfd52","5135":"6714c181"}[chunkId] + ".chunk.css";
};